export default function findImageByProjectNameOrType(projectGroup: string) {
  const repositoryTemplates = [
    'smart-care-federated-repository',
    'smart-care-virtual-repository',
    'smart-care-remote-repository',
    'daniel-federated-repository',
    'daniel-virtual-repository',
    'daniel-remote-repository',
  ];

  if (repositoryTemplates.includes(projectGroup)) {
    return require(`../images/artifact management.png`);
  }

  try {
    if (projectGroup.startsWith('.')) {
      projectGroup = projectGroup.substring(1);
    }
    return require(`../images/${projectGroup.toLowerCase()}.png`);
  } catch (e) {
    try {
      if (projectGroup.startsWith('.')) {
        projectGroup = projectGroup.substring(1);
      }
      return require(`../images/${projectGroup.toLowerCase()}.drawio.png`);
    } catch (e) {
      return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    }
  }
}
